<template>
  <div class="p-login-form-suppl">
    パスワードをお忘れの方は<a class="p-login-form-suppl__link" :href="passwordResetUrl">こちら</a>
  </div>
</template>

<script>
export default {
  props: {
    passwordResetUrl: String,
  },
}
</script>
